<template>
  <v-container class="pa-1">
    <v-layout>
      <v-flex xs12>
        <!-- list of units -->
        <v-card flat>
          <v-card-title class="pt-2 caption">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="search"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search by unit no., bhk, sq ft, etc.':'Search'"
                single-line
                hide-details
                v-model="search"
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-download-as
                :headers="unitHeadSm"
                :items="units"
                title="Unit list"
                ></v-download-as>
              </v-flex>
            </v-layout>

          </v-card-title>
          <v-card-text class="pa-1">
            <v-data-table
            :headers="$vuetify.breakpoint.smAndUp?unitHeadSm:unitHead"
            :items="units"
            hide-actions
            class="elevation-3"
            :search="search"
            disable-initial-sort
            >
            <template slot="items" slot-scope="props">
              <tr @click="prepareUpdate(props.item)">
                <td>{{ props.item.block_nm }}</td>
                <td>{{ props.item.unit_no }}</td>
                <td>{{ props.item.bhk }}</td>
                <td>{{ props.item.acc_sqft }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp" :class="props.item.is_rented ? 'accent--text' : ''">{{ props.item.is_rented ? 'Yes' : 'No' }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp" :class="props.item.is_billed_to_tenant ? 'accent--text' : ''">{{ props.item.is_billed_to_tenant ? 'Yes' : 'No' }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp" :class="props.item.is_vacant ? 'accent--text' : ''">{{ props.item.is_vacant ? 'Yes' : 'No' }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.spcl_cat }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- dialog update unit details -->
      <v-dialog v-model="isUpdated" max-width="300px">
        <v-card>
          <v-card-title>
            <span class="headline">{{lUnit.block_nm + ' ' + lUnit.unit_no}}</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <v-combobox
                  label="BHK"
                  v-model="lUnit.bhk"
                  :rules="[rules.required]"
                  :items="bhkList"
                  type="number"
                  ></v-combobox>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  label="Sq Ft"
                  v-model="lUnit.acc_sqft"
                  :rules="[rules.required]"
                  type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                  label="Vacant"
                  v-model="lUnit.is_vacant"
                  @change="lUnit.is_rented = lUnit.is_rented && lUnit.is_vacant ? false : lUnit.is_rented"
                  hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                  label="Rented out"
                  v-model="lUnit.is_rented"
                  :disabled="lUnit.is_vacant"
                  hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                  label="Billed to tenant"
                  v-model="lUnit.is_billed_to_tenant"
                  :disabled="!lUnit.is_rented || lUnit.is_vacant"
                  hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                  label="Special billing category (optional)"
                  v-model="lUnit.spcl_cat"
                  maxlength="15"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
            <v-btn :disabled="Number(lUnit.acc_sqft) <= 0" color="accent" flat @click.native="saveChanges">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- end of screen specific -->

      <!-- common elements for alert & loading spinner -->
      <v-snackbar :color="sbarCol" v-model="sbar" :timeout="2000" multi-line>
        <span class="mx-auto">{{ sbarMsg }}</span>
      </v-snackbar>

      <div v-if="load" style="position:absolute; top:20%; left:50%">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  props: ['action'],
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      load: false,
      rules: handy.rules,

      // screen specific
      lUnit: '',
      units: [],
      bhkList: [],
      unitHead: [
        { text: 'Block', value: 'block_nm' },
        { text: 'Unit', value: 'unit_no' },
        { text: 'BHK', value: 'bhk' },
        { text: 'Sq Ft', value: 'acc_sqft' }
      ],
      unitHeadSm: [
        { text: 'Block', value: 'block_nm' },
        { text: 'Unit', value: 'unit_no' },
        { text: 'BHK', value: 'bhk' },
        { text: 'Sq Ft', value: 'acc_sqft' },
        { text: 'Rented?', value: 'is_rented' },
        { text: 'Billed To Tenant?', value: 'is_billed_to_tenant' },
        { text: 'Vacant?', value: 'is_vacant' },
        { text: 'Special Billing Category', value: 'spcl_cat' }
      ],
      isUpdated: false,
      search: ''
    }
  }, // data
  created () {
    this.loadUnits()
  },
  methods: {
    // common methods
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
      setTimeout(() => {
        this.load = false
      }, 2000)
    },
    // screen specific methods
    loadUnits () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getUnitsByCommId/', qry)
      .then(response => {
        this.units = response.data
        this.bhkList = this.units.filter(rec => rec.bhk).map(rec => rec.bhk)
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.units = []
      })
    },
    prepareUpdate (curUnit) {
      this.lUnit = Object.assign({}, curUnit) // keep the original object safely before changes
      this.lUnit.prev_rented = this.lUnit.is_rented
      this.isUpdated = true
    },
    saveChanges () {
      if (!this.lUnit.is_rented) {
        if (this.lUnit.prev_rented) {
          if (!confirm('WARNING: Updating rental flag will delink all the tenants and revoke their access from this house automatically')) {
            this.$forceUpdate()
            return
          }
        }
      }

      this.lUnit.is_billed_to_tenant = this.lUnit.is_rented ? this.lUnit.is_billed_to_tenant : false
      this.lUnit.user_id = config.USER_ID
      this.axios.post(config.API_URL + '/unit/update', this.lUnit)
      .then(response => {
        // update the table
        var idx = this.units.findIndex(obj => obj.unit_id === this.lUnit.unit_id)
        Object.assign(this.units[idx], this.lUnit)
        // update global config if user changing one of his units (though he supposted change under his/her profile only)
        idx = config.UNITS.findIndex(obj => obj.unit_id === this.lUnit.unit_id)
        if (idx >= 0) {
          config.UNITS[idx].is_rented = this.lUnit.is_rented
          config.UNITS[idx].is_billed_to_tenant = this.lUnit.is_billed_to_tenant
        }
        this.isUpdated = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    cancelChanges () {
      this.isUpdated = false
    }
  } // methods
} // export
</script>



// WEBPACK FOOTER //
// Unit.vue?a0b63b10